import type * as UpdateCustomerOrderItem from '@ori-events/update-customer-order-item';
import * as UpdateCustomerOrderItemFailed from '@ori-events/update-customer-order-item-failed';
import type { PositionData } from '@ori/analytics-data';

import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

type Data = PositionData & UpdateCustomerOrderItem.Data;

export async function updateCustomerOrderItemHandler({
  detail: { endConsumerOrderId, itemCode, placement, requestedQuantity },
}: CustomEvent<Data>) {
  const fetchUrl =
    `${RequestUrl.UpdateCustomerOrderItem}` +
    `?endConsumerOrderId=${endConsumerOrderId}` +
    `&itemCode=${itemCode}` +
    `&requestedQuantity=${requestedQuantity}`;

  const response = await fetch(fetchUrl, getHttpRequestSettings({ placement }));
  const data = convertToCamelCase<UpdateCustomerOrderItemFailed.UpdateCustomerOrderItemResponse>(
    (await response.json()) as object,
  );

  if (UpdateCustomerOrderItemFailed.isUpdateCustomerOrderItemErrorResponse(data)) {
    const errorEvent = new CustomEvent<UpdateCustomerOrderItemFailed.Data>(UpdateCustomerOrderItemFailed.Name, {
      detail: data,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return data;
}
